module.exports = __webpack_public_path__ + "img/editdavanced.a9f890b7.webp";